import { render, staticRenderFns } from "./pavilionAppointDetails.vue?vue&type=template&id=55e42b01&scoped=true"
import script from "./pavilionAppointDetails.vue?vue&type=script&lang=js"
export * from "./pavilionAppointDetails.vue?vue&type=script&lang=js"
import style0 from "./pavilionAppointDetails.vue?vue&type=style&index=0&id=55e42b01&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e42b01",
  null
  
)

export default component.exports